import { Row, Col, Container } from "react-bootstrap"
import ProfileImage from "../../components/ProfileImage"

import { useEffect, useState } from "react"
import Loading from "../../components/Loading"
import { useCompanies } from "../../api/companies/store"
import { useAuth } from "../../api/auth/store"
import { CompanyData } from "../../api/auth/actions"
import Branches from "../../containers/Company/Branches"
import CompanyDeviceApproval from "./CompanyDeviceApproval"
import CompanyIpWhitelist from "./CompanyIpWhitelist"
import EditableControl, { EditableLabel } from "../../components/EditableControl"
import { ADMIN_ROLE, OWNER_ROLE, SUPPORT_ROLE } from "../../constants"

const CompanyProfileCard = () => {
    const { profile, retrieveCompanyProfile, uploadComAvatar, hasRole } = useAuth(state => state)
    const { updateCompany } = useCompanies(state => state)
    const [loadingAvatar, setLoadingAvatar] = useState(false)
    const [editDetails, setEditDetails] = useState<CompanyData | null>(null)
    useEffect(() => {
        if (profile !== null) return
        setLoadingAvatar(true)
        retrieveCompanyProfile()
            .then(res => {
                if (res === "200") {
                    setEditDetails(profile)
                }
            })
            .finally(() => setLoadingAvatar(false))
    }, [])

    //console.log(sessionDetails)
    if (profile === null) return <Loading center />

    if (!editDetails) setEditDetails(profile)

    const onUploadAvatar = (img: File) => {
        // TODO: compress the uploaded images
        // https://dev.to/franciscomendes10866/image-compression-with-golang-k2p
        setLoadingAvatar(true)
        uploadComAvatar(img).finally(() => setLoadingAvatar(false))
    }
    const onApply = (data: CompanyData) => {
        updateCompany(data!)
    }

    const editable = (hasRole(ADMIN_ROLE) || hasRole(OWNER_ROLE)) && !hasRole(SUPPORT_ROLE)
    // company image should only be editable by authorized role
    return <EditableControl editable={editable} defaultData={editDetails} onApply={onApply}>
        {(data, onChanged, edit) => (
            <Container>
                <Row style={{ padding: 15 }}>
                    <Col sm="auto" style={{ padding: "0 25px 0 0" }}>
                        <div>
                            <ProfileImage loading={loadingAvatar} editable={editable} src={profile?.img} name={profile.name} size={80} bgcolor="rgb(217, 217, 217)" onChanged=
                                {onUploadAvatar} />
                        </div>
                    </Col>
                    <Col >
                        <EditableLabel label="Id" value={editDetails?.id} />
                        <EditableLabel edit={edit} label="Name"
                            value={data?.name}
                            onChanged={(val) => onChanged("name", val)} />
                        <EditableLabel label="Owner" value={editDetails?.owner} />
                    </Col>
                </Row>
            </Container>
        )}
    </EditableControl>
}

type CompanyProfileProps = {
    subpage?: string
}

const CompanyProfilePage: React.FC<CompanyProfileProps> = ({ subpage }) => {
    const [currentPage, setCurrentPage] = useState(subpage || "profile")

    useEffect(() => {
        if (subpage) {
            setCurrentPage(subpage)
        }
    }, [subpage])

    switch (currentPage) {
        case "profile":
            return <>
                <CompanyProfileCard />
                <Branches />
            </>
        case "devices":
            return <CompanyDeviceApproval />
        case "ip-whitelist":
            return <CompanyIpWhitelist />
        default:
            return <>
                <CompanyProfileCard />
                <Branches />
            </>
    }
}

export default CompanyProfilePage
